import InformationButton from "../../../../components/molecules/InformationButton"
import { loc } from "../../../../core/utils"
import NumberField from "../../../../form/NumberField"
import React from "react"

const DOT_KEY_CODE = 190
const COMMA_KEY_CODE = 188

function handleKeyDown(event) {
  if (event.keyCode === COMMA_KEY_CODE || event.keyCode === DOT_KEY_CODE) {
    event.preventDefault()
  }
}

export default function ItalianIncomeNumberField({ isDisabled }) {
  return (
    <NumberField
      name="situation.netMonthlyIncome"
      label={loc("Your net monthly income")}
      placeholder="€"
      inputmode="numeric"
      disabled={isDisabled}
      onKeyDown={handleKeyDown}
    >
      <InformationButton overlayText={loc("validator_invalidNetMounthlyIncomeFormat")} />
    </NumberField>
  )
}
